import { css } from 'styled-components';
export var sizes = {
  desktop: 992,
  tablet: 768,
  phone: 400,
  // These sizes conform to bootstraps grid sizings:
  // https://getbootstrap.com/docs/4.0/layout/grid/#grid-options
  extraSmall: 576,
  small: 768,
  medium: 992,
  large: 1200,
  // extraLarge is the only one that uses a min-width query
  extraLarge: 1201
};
/**
 * Helper for generating media queries in styled components. Each key of the
 * object wraps the provided css in a media query with a `max-width` dependent
 * on the key used.
 *
 * **Sizes**
 *
 * // https://getbootstrap.com/docs/4.0/layout/grid/#grid-options
 * extraSmall: `576`
 * small: `768`
 * medium: `992`
 * large: `1200`
 * extraLarge: `1201` // extraLarge is the only one that uses a min-width query
 *
 * desktop: `992px`
 * tablet: `768px`
 * phone: `400px`
 *
 * Nearly identical to the example [here](https://www.styled-components.com/docs/advanced#media-templates)
 *
 * @public
 * @author Connor Taylor
 *
 * @example
 *
 * css`
 *   background: #f00;
 *
 *   // @media(max-width: 400px)
 *   ${media.phone`
 *     background: #0f0;
 *   `}
 *
 *   // @media(max-width: 768px)
 *   ${media.tablet`
 *     background: #00f;
 *   `}
 * `;
 *
 */

var media = Object.keys(sizes).reduce(function (acc, label) {
  if (label === "extraLarge") {
    acc[label] = function () {
      return css(["@media (min-width:", "px){", ";}"], sizes[label], css.apply(void 0, arguments));
    };
  } else {
    acc[label] = function () {
      return css(["@media (max-width:", "px){", ";}"], sizes[label], css.apply(void 0, arguments));
    };
  }

  return acc;
}, {});
/** @component */

export default media;